export default {
      id: "schedule-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#schedule",
      toString: function () {
        return this.url;
      }
    }